import BreadCrumb from "../screens/Common/BreadCrumb";
import React from "react";

import LayoutContainer from "../screens/layout/admin-dashboard";
import CategoryFolderList from "../screens/CategoryDocumentUpload/CategoryFolderList";

const breadCrumbData = [{ link: "/project-folder-list", name: "Project Folder" }];
const CategoryManagement = () => (
  <>
    <LayoutContainer>
      <BreadCrumb data={breadCrumbData} />
      <CategoryFolderList />
    </LayoutContainer>
  </>
);

export default CategoryManagement;